module.exports = __webpack_public_path__ + "img/ad3.b2a96dd3.png";